import { useMemo } from 'react';

import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useArticlePageSettings: UseMainUIFeatureSettings<'articlePage'> = (options) => {
  const longFormContentOverrides = options?.overrides?.articlePage;

  return useMemo(
    () => ({
      [uiFeatureAccessSymbol]: true,
      ...longFormContentOverrides,
    }),
    [longFormContentOverrides]
  );
};
